import v4EssayCopy from './v4-essay-copy.json';

// Boulder Ventures Perspectives — V4 spatial content model
// Coordinates are normalized world-space hints: x west/east, z south/north,
// elevationOffset floats rope/cairns above sampled terrain.

export const themes = {
  laws: { label: 'The Laws', color: '#c95b39', terrain: 'exposed-ridge', symbol: 'piton' },
  craft: { label: 'The Craft', color: '#16264b', terrain: 'granite-spine', symbol: 'rope-coil' },
  people: { label: 'People & Portraits', color: '#4b91cf', terrain: 'high-cirque', symbol: 'portrait-flag' },
  portfolio: { label: 'Portfolio & Markets', color: '#d9a62e', terrain: 'weather-front', symbol: 'survey-marker' },
  place: { label: 'Boulder & Place', color: '#398476', terrain: 'foothill-traverse', symbol: 'compass' },
  culture: { label: 'Culture & Life', color: '#8365a6', terrain: 'sheltered-camp', symbol: 'lantern' },
};

const rawEssays = [
 ['if-youre-right','If you’re right about the entrepreneur…','2020-10','craft','The founding thesis: back serial entrepreneurs. If you are wrong about both the person and the plan, you get to lose all the money.'],
 ['mountain-guide-vc','Being a Mountain Guide and being a Venture Capitalist is the same thing','2020-11','craft','The master metaphor: the client is the entrepreneur, the weather is the market, and the route is the company. Great entrepreneurs choose their guides.'],
 ['durability','Durability is the Key to Success','2020-12','laws','It takes a decade to find out if you are any good. Survive long enough to develop the skills.'],
 ['original-mistakes','Our Goal is to make Original Mistakes','2021-01','laws','Share every mistake across the portfolio so each company only makes new ones.'],
 ['no-safe','There is no such thing as safe','2021-02','laws','Risk can be reduced, never eliminated.'],
 ['guide-pins','Mountain Guide Pins','2021-03','people','What the pin certifies, and what a Lifetime Member pin means when competence is the only currency.'],
 ['sandbag-excellence','Sandbag Excellence: The Lesson of Henry Barber','2021-04','laws','Set expectations below the likely outcome; exceptional execution should exceed the promise.'],
 ['no-tasty-talk','No Tasty Talk','2021-05','laws','State the obvious in clear, precise language, no matter how uncomfortable.'],
 ['authentic-relationships','Authentic Relationships','2021-06','craft','Durable relationships are built across careers, longer than any single deal.'],
 ['good-vc-bad-vc','Good VC vs Bad VC','2021-07','craft','Anyone with committed capital and a business card can claim the title; behavior reveals the guide.'],
 ['slaters-law','Slater’s Law','2021-08','laws','The climb is not over until the ropes are on the ground; no fund succeeds until LPs are paid.'],
 ['where-matters','Where Matters','2021-09','place','Boulder uniquely joins serious climbing terrain with a serious venture ecosystem.'],
 ['judgement-experience','Good Judgement Comes from Experience; Experience Comes from Bad Judgement','2021-10','laws','Success can be a testament to luck as much as talent; experience changes future judgment.'],
 ['early-is-wrong','Being Early is the Same as Being Wrong','2021-11','laws','Timing is part of the thesis.'],
 ['good-style','In Good Style','2021-12','craft','Choose the right route, stay ahead of the crowd, keep documents clean, and close as promised.'],
 ['perfect-enemy','Don’t Let the Perfect be the Enemy of the Good','2022-01','laws','Good is achievable, great sometimes in reach, flawless possible, perfect not.'],
 ['never-leave-snow','Never Leave Snow to Find Snow','2022-02','laws','Once you find the right aspect, elevation, and market, keep working it.'],
 ['bouldering','Bouldering','2022-03','people','Mastery of the small problem scales.'],
 ['stacked-blocks','Stacked Blocks','2022-04','craft','There is always a path through the stacked blocks; experience is what finds it.'],
 ['safety-drinking','Safety First, Then Drinking','2022-05','culture','Celebrating properly is a professional skill, after the disciplined work is done.'],
 ['living-future','Living in the Future','2022-06','portfolio','The best founders live in the future and build what is missing.'],
 ['what-we-do','What We Do','2022-07','craft','There is no instruction manual; the job is judgment in conditions no checklist covers.'],
 ['satisfying-work','Satisfying Work','2022-08','culture','Satisfying work is complex, autonomous, and connects effort to reward.'],
 ['sicily-haston','In Sicily, with Haston','2022-09','culture','A long table reveals things no diligence call can surface.'],
 ['competence-hierarchy','The Competence Hierarchy','2022-10','craft','The only hierarchy worth trusting is competence demonstrated to peers.'],
 ['right-thing','Do the Right Thing','2022-11','craft','Duty is what you do when it costs you something.'],
 ['becoming-yourself','Becoming Yourself','2022-12','people','Practice the person you mean to become until the role becomes real.'],
 ['the-deal','The Deal','2023-01','portfolio','The deal you avoid cannot get you fired, which is exactly the problem.'],
 ['diny','Diny','2023-02','people','Competence demonstrated to credentialed peers is the only hierarchy worth climbing.'],
 ['food-wine','Food and Wine','2023-03','place','Place shapes the partnership as much as terrain does.'],
 ['sound-fury','Sound & Fury','2023-04','people','Some people are the signal; the rest is noise.'],
 ['boards-matter','Boards Matter','2023-05','portfolio','Two questions decide everything: who runs the company, and who owns it.'],
 ['partnership','Partnership','2023-06','portfolio','Back the same people across companies and decades.'],
 ['guiding-boulder','Guiding in Boulder','2023-07','portfolio','People, culture, and DPI form the trilogy; distributions are the long-term measure.'],
 ['markers-margins','Markers and Margins','2023-08','laws','Decide the no-go before you go, preserving enough margin to help others on descent.'],
 ['tourists','Tourists','2023-09','laws','Guides lead clients through terrain; tourists repeat the same viewpoint.'],
 ['high-k2','High on K2','2023-12','people','The personal stories explain why anyone chooses this work at all.'],
 ['brevity','Brevity','2024-09','laws','Clarity is compression: say exactly what the company does and why it matters.'],
 ['ski-vail','How to Ski Vail on a Powder Day','2024-09','place','Local knowledge is a compounding asset.'],
 ['alternative-guiding','An Alternative History of Mountain Guiding','2024-10','people','One consequential decision can reroute a profession’s history.'],
 ['educated-jew','An Educated Jew','2024-10','people','Family standards are set by doing the right thing when courage has a real cost.'],
 ['coombs-law','Coombs’ Law','2024-10','laws','Control effort, attitude, and preparation; perform in every condition.'],
 ['cry-angel','Cry Like an Angel','2025-07','culture','The clock is the point; spend finite days on people and mountains that deserve them.'],
 ['ken-patti','Ken and Patti','2025-08','people','Know the difference between a commodity and the business that sells it.'],
 ['our-culture','Our Culture','2025-08','culture','Culture is the only sustainable advantage; everything else can be copied or hired away.'],
 ['witchdoctors','Witchdoctors','2025-09','laws','Incumbents defend the disease your product cures; persistence outlasts them.'],
 ['breakthroughs','Breakthroughs','2025-10','people','A real breakthrough has a visible cost from the inside.'],
 ['building-bridges','Building Bridges','2025-11','place','Infrastructure for a community is built with the same durable care as a firm.'],
 ['revy','Revy the Berner','2025-12','culture','The business lessons carry weight because the writer tells the truth about everything else.'],
 ['geography-risk','The Geography of Risk','2026-02','people','He never left his mountain; the rope is still not on the ground.'],
 ['artists-mill','The Artist’s Mill','2026-04','people','Translate force into joy; rebuild what burned into something generous.'],
 ['guides-fall','When Guides Fall','2026-04','people','A profession reveals itself in how it remembers and mourns its own.'],
 ['small-plants','A Few Small Plants','2026-05','portfolio','Repeat partnerships compound; a few small plants can change the world.'],
 ['openai-craters','What If OpenAI Craters?','2026-05','portfolio','Infrastructure theses can survive the flagship’s crash; durability makes early survivable.'],
 ['team-ascent','Team Ascent','2026-06','craft','The hardest routes fall to teams whose members could each lead and choose to share the rope.'],
];

export const essays = rawEssays.map(([id,title,date,theme,takeaway], index) => ({
  id, index, title, date, theme, takeaway,
  year: Number(date.slice(0,4)), month: Number(date.slice(5,7)),
  url: `/boulder-ventures-complete#article-${rawEssays.length-index}`,
  canonicalUrl: `/boulder-ventures-complete#article-${rawEssays.length-index}`,
  marker: index === 0 ? 'trailhead' : index === rawEssays.length - 1 ? 'high-point' : 'cairn',
}));

const legacyRouteControlPoints = {
  craft: [
    [-0.76,0.03,-0.80],[-0.58,0.05,-0.61],[-0.72,0.06,-0.38],[-0.46,0.07,-0.16],[-0.55,0.075,0.08],[-0.28,0.08,0.31],[-0.38,0.09,0.53],[-0.10,0.10,0.74],[0.00,0.12,0.92]
  ],
  laws: [
    [-0.72,0.03,-0.83],[-0.35,0.05,-0.70],[-0.52,0.06,-0.49],[-0.14,0.075,-0.30],[-0.36,0.08,-0.08],[0.02,0.09,0.16],[-0.20,0.10,0.39],[0.10,0.11,0.62],[0.02,0.13,0.92]
  ],
  people: [
    [-0.68,0.03,-0.86],[-0.13,0.045,-0.76],[-0.28,0.06,-0.55],[0.06,0.07,-0.38],[-0.15,0.08,-0.13],[0.18,0.09,0.08],[-0.08,0.10,0.32],[0.17,0.115,0.58],[0.03,0.13,0.91]
  ],
  portfolio: [
    [-0.64,0.03,-0.88],[0.08,0.045,-0.79],[-0.02,0.06,-0.58],[0.33,0.07,-0.43],[0.12,0.08,-0.20],[0.43,0.09,0.02],[0.18,0.10,0.26],[0.35,0.115,0.52],[0.05,0.13,0.91]
  ],
  place: [
    [-0.62,0.03,-0.91],[0.31,0.04,-0.84],[0.20,0.055,-0.64],[0.58,0.065,-0.48],[0.31,0.08,-0.26],[0.66,0.09,-0.03],[0.36,0.10,0.23],[0.55,0.115,0.50],[0.08,0.13,0.90]
  ],
  culture: [
    [-0.60,0.03,-0.94],[0.54,0.04,-0.88],[0.38,0.055,-0.69],[0.79,0.065,-0.53],[0.52,0.075,-0.31],[0.82,0.085,-0.07],[0.52,0.10,0.19],[0.70,0.115,0.47],[0.10,0.13,0.89]
  ],
};

const legacyRoutes = Object.entries(legacyRouteControlPoints).map(([id,points], order) => ({
  id, order, ...themes[id], points: points.map(([x,elevationOffset,z]) => ({x,z,elevationOffset})),
  essayIds: essays.filter(e => e.theme === id).map(e => e.id),
  trailheadLabel: order < 2 ? 'Chautauqua Meadow' : 'Boulder Base Camp',
  destinationLabel: 'Unfinished high point',
}));

export const landmarks = [
  { id:'boulder', name:'Boulder', kind:'city', position:{x:-0.86,z:-0.94}, elevationFt:5430, labelPriority:1, reveal:'opening' },
  { id:'chautauqua', name:'Chautauqua Meadow', kind:'trailhead', position:{x:-0.64,z:-0.88}, elevationFt:5686, labelPriority:1, reveal:'opening' },
  { id:'first-flatiron', name:'First Flatiron', kind:'formation', position:{x:-0.49,z:-0.56}, elevationFt:7312, labelPriority:1, reveal:'approach' },
  { id:'second-flatiron', name:'Second Flatiron', kind:'formation', position:{x:-0.34,z:-0.52}, elevationFt:7300, labelPriority:2, reveal:'approach' },
  { id:'third-flatiron', name:'Third Flatiron', kind:'formation', position:{x:-0.20,z:-0.48}, elevationFt:7280, labelPriority:1, reveal:'approach' },
  { id:'flagstaff', name:'Flagstaff Mountain', kind:'summit', position:{x:-0.69,z:-0.31}, elevationFt:6983, labelPriority:2, reveal:'foothills' },
  { id:'green', name:'Green Mountain', kind:'summit', position:{x:-0.25,z:-0.08}, elevationFt:8148, labelPriority:1, reveal:'foothills' },
  { id:'bear', name:'Bear Peak', kind:'summit', position:{x:0.15,z:0.12}, elevationFt:8459, labelPriority:1, reveal:'treeline' },
  { id:'south-boulder', name:'South Boulder Peak', kind:'summit', position:{x:0.34,z:0.19}, elevationFt:8549, labelPriority:2, reveal:'treeline' },
  { id:'eldorado', name:'Eldorado Canyon', kind:'canyon', position:{x:0.62,z:-0.28}, elevationFt:6000, labelPriority:2, reveal:'foothills' },
  { id:'indian-peaks', name:'Indian Peaks', kind:'range', position:{x:0.26,z:0.66}, elevationFt:13100, labelPriority:1, reveal:'high-alpine' },
  { id:'continental-divide', name:'Continental Divide', kind:'ridge', position:{x:0.02,z:0.83}, elevationFt:12500, labelPriority:1, reveal:'high-alpine' },
  { id:'longs', name:'Longs Peak', kind:'distant-peak', position:{x:-0.17,z:0.96}, elevationFt:14259, labelPriority:1, reveal:'summit' },
];

const legacyChapters = [
  { id:'trailhead', label:'Choose a line', start:0, end:1, altitude:[5430,5750], weather:'dawn-clear', camera:'meadow-reveal', narration:'Six ropes leave the same meadow. Every route is a way of seeing the same mountain.' },
  { id:'first-lessons', label:'First protection', start:2, end:10, altitude:[5750,7000], weather:'morning-calm', camera:'flatirons-push', narration:'The early laws are protection placed before exposure: durability, candor, risk, and the discipline to finish.' },
  { id:'foothills', label:'Find your style', start:11, end:19, altitude:[7000,8200], weather:'building-cloud', camera:'switchback-follow', narration:'Place and practice converge. The routes split, cross, and begin to reveal a house style.' },
  { id:'treeline', label:'No instruction manual', start:20, end:27, altitude:[8200,9600], weather:'wind-rising', camera:'forest-to-rock', narration:'Above treeline, checklists stop helping. Judgment, partnership, and lived experience take over.' },
  { id:'exposure', label:'Markers and margins', start:28, end:36, altitude:[9600,11100], weather:'storm-front', camera:'ridge-traverse', narration:'Boards, partnership, and market weather arrive together. The route is exposed; margin becomes visible.' },
  { id:'long-traverse', label:'The quiet traverse', start:37, end:41, altitude:[11100,12000], weather:'whiteout-to-blue', camera:'time-compression', narration:'Nine months pass between cairns. The empty terrain is part of the archive, not a gap to hide.' },
  { id:'high-alpine', label:'Finite days', start:42, end:49, altitude:[12000,13300], weather:'golden-cold', camera:'cirque-orbit', narration:'Culture becomes personal. Time, inheritance, community, and loss become the highest terrain.' },
  { id:'unfinished', label:'Rope still out', start:50, end:54, altitude:[13300,14259], weather:'summit-clouds', camera:'summit-continue', narration:'The newest cairn is only the highest occupied point. The rope continues into weather. The fund is not done.' },
];

const legacyGuidedAscent = [
  { at:0, action:'flyTo', target:'boulder', duration:5, audio:'morning-wind', caption:'Boulder, Colorado · 5,430 ft' },
  { at:1, action:'revealRoutes', target:'chautauqua', duration:4, caption:'Six years. Six routes. One unfinished ascent.' },
  { at:2, action:'focusEssay', target:'mountain-guide-vc', duration:7, caption:'The client is the entrepreneur. The weather is the market. The route is the company.' },
  { at:3, action:'followTheme', target:'laws', duration:10, caption:'Protection before exposure.' },
  { at:4, action:'weatherShift', target:'storm-front', duration:5, caption:'Conditions change. The rope holds.' },
  { at:5, action:'focusEssay', target:'slaters-law', duration:7, caption:'It is not over until the ropes are on the ground.' },
  { at:6, action:'orbitConvergence', target:'boards-matter', duration:10, caption:'People, ownership, and judgment converge on the ridge.' },
  { at:7, action:'traverseGap', target:'long-traverse', duration:8, caption:'Nine months. No cairn. Keep moving.' },
  { at:8, action:'focusEssay', target:'cry-angel', duration:7, caption:'The clock is the point.' },
  { at:9, action:'gatherRoutes', target:'team-ascent', duration:10, caption:'Each could lead. They choose to share the rope.' },
  { at:10, action:'continueRope', target:'beyond-summit', duration:8, caption:'Highest occupied point · not the end.' },
];

const legacyExpedition = {
  title:'Perspectives', subtitle:'Six routes through six years of field notes',
  timeRange:['2020-10','2026-06'], elevationRangeFt:[5430,14259],
  metaphor:{ client:'entrepreneur', weather:'market', route:'company', completion:'rope on the ground' },
  themes, essays, routes:legacyRoutes, landmarks, chapters:legacyChapters, guidedAscent:legacyGuidedAscent,
};

function validateLegacyExpedition(data = legacyExpedition) {
  const ids = new Set(data.essays.map(e => e.id));
  const errors = [];
  if (data.essays.length !== 55) errors.push(`Expected 55 essays, got ${data.essays.length}`);
  if (ids.size !== data.essays.length) errors.push('Essay ids are not unique');
  for (const route of data.routes) {
    if (route.points.length < 4) errors.push(`${route.id} route needs more control points`);
    for (const id of route.essayIds) if (!ids.has(id)) errors.push(`${route.id} references missing essay ${id}`);
  }
  const covered = data.chapters.flatMap(c => Array.from({length:c.end-c.start+1},(_,i)=>c.start+i));
  if (new Set(covered).size !== 55 || Math.min(...covered) !== 0 || Math.max(...covered) !== 54) errors.push('Chapters do not cover essay indices 0–54 exactly');
  return { valid: errors.length === 0, errors };
}


// ── V5 narrative system ──────────────────────────────────────────────────────
// One chronological rope carries the complete archive. Themes are lenses and
// physical artifact types encountered on that rope, never competing routes.

export const artifactTypes = {
  laws: {
    lineLabel: 'The Laws',
    id: 'protection',
    singular: 'piton',
    plural: 'protection',
    verb: 'Protect',
    description: 'Rules placed before exposure: limits, candor, durability, and the obligation to finish.',
    sceneObject: 'piton',
    material: 'weathered-rust',
    light: '#c95720',
  },
  craft: {
    lineLabel: 'The Craft',
    id: 'ropework',
    singular: 'rope station',
    plural: 'rope systems',
    verb: 'Practice',
    description: 'Judgment made visible through systems, partnership, repetition, and style.',
    sceneObject: 'rope-coil',
    material: 'ink-navy',
    light: '#45a2f6',
  },
  people: {
    lineLabel: 'People & Portraits',
    id: 'rope-team',
    singular: 'portrait flag',
    plural: 'portraits',
    verb: 'Remember',
    description: 'The people who teach, lead, inherit, break through, and sometimes fall.',
    sceneObject: 'portrait-flag',
    material: 'photo-cloth',
    light: '#e9e1ce',
  },
  portfolio: {
    lineLabel: 'Portfolio & Markets',
    id: 'conditions',
    singular: 'weather station',
    plural: 'market conditions',
    verb: 'Read conditions',
    description: 'Companies, boards, ownership, and markets read as changing weather.',
    sceneObject: 'weather-station',
    material: 'signal-yellow',
    light: '#fac832',
  },
  place: {
    lineLabel: 'Boulder & Place',
    id: 'bearings',
    singular: 'bearing marker',
    plural: 'bearings',
    verb: 'Orient',
    description: 'Boulder, local knowledge, and community infrastructure anchor the expedition.',
    sceneObject: 'compass-marker',
    material: 'boulder-blue',
    light: '#4ca1f5',
  },
  culture: {
    lineLabel: 'Culture & Life',
    id: 'shelter',
    singular: 'campfire',
    plural: 'shelters',
    verb: 'Gather',
    description: 'The meals, rituals, grief, animals, and finite days that explain why the work matters.',
    sceneObject: 'campfire',
    material: 'ember-gold',
    light: '#f7c531',
  },
};

const majorStationSpecs = {
  'mountain-guide-vc': {
    stationId:'the-metaphor', scene:'map-rises', object:'unfurled-map', chapter:'departure',
    kicker:'The governing metaphor', duration:14,
    caption:'The client is the entrepreneur. The weather is the market. The route is the company.',
    editorial:'Great entrepreneurs choose their guides.',
    light:'brick-dawn', weather:'clear-cold', camera:'pearl-to-chautauqua',
  },
  'slaters-law': {
    stationId:'rope-on-ground', scene:'first-belay', object:'anchor-and-rope', chapter:'protection',
    kicker:'What completion means', duration:13,
    caption:'Rob Slater refused the summit handshake. Twice.',
    editorial:'“The Tower’s not over until the ropes are on the ground.” No fund succeeds until LPs are paid.',
    light:'rust-morning', weather:'high-thin-cloud', camera:'anchor-close-to-flatirons',
  },
  'where-matters': {
    stationId:'boulder-reveal', scene:'flatirons-reveal', object:'compass', chapter:'place',
    kicker:'The home terrain', duration:12,
    caption:'Only a few great guiding ranges. Only two great U.S. venture centers.',
    editorial:'Boulder is the only place to be a serious climber and a serious VC at once.',
    light:'front-range-gold', weather:'bluebird', camera:'flatirons-profile',
  },
  'competence-hierarchy': {
    stationId:'earned-authority', scene:'rope-team-belay', object:'rope-station', chapter:'judgment',
    kicker:'Who gets to lead', duration:12,
    caption:'No money, politics, or ancestry buys an IFMGA pin.',
    editorial:'“Most VCs were born on third base.” In guiding, incompetence costs lives; in VC, someone else’s money.',
    light:'hard-noon', weather:'wind-building', camera:'belay-orbit',
  },
  'guiding-boulder': {
    stationId:'measure-that-matters', scene:'weather-observatory', object:'weather-station', chapter:'exposure',
    kicker:'The long-term measure', duration:12,
    caption:'BV8 closed at $58M in a frozen market.',
    editorial:'People. Culture. DPI—the only long-term measure of a fund’s success.',
    light:'storm-edge', weather:'front-arriving', camera:'ridge-weather-push',
  },
  'markers-margins': {
    stationId:'no-go-line', scene:'exposed-ridge', object:'margin-markers', chapter:'exposure',
    kicker:'Decide before exposure', duration:13,
    caption:'Denali, 2023. The weather window never came.',
    editorial:'They changed objectives—and kept enough margin to rescue two frostbitten climbers on descent.',
    light:'slate-afternoon', weather:'storm-near', camera:'ridge-traverse-low',
  },
  'tourists': {
    stationId:'guide-or-tourist', scene:'forked-tracks', object:'route-sign', chapter:'exposure',
    kicker:'A consequential distinction', duration:10,
    caption:'Lake Louise: busloads, one viewpoint, the same photograph.',
    editorial:'“We’re Guides. Our Serial Entrepreneurs are our Clients. We’re never Tourists.”',
    light:'storm-break', weather:'crosswind', camera:'fork-crossing',
  },
  'high-k2': {
    stationId:'the-personal-reason', scene:'night-bivouac', object:'portrait-flag', chapter:'whiteout',
    kicker:'Why choose this work', duration:14,
    caption:'Billy Coburn, high on the mountain.',
    editorial:'The stories that explain why anyone does this at all.',
    light:'bivouac-night', weather:'stars-and-spindrift', camera:'campfire-intimate',
  },
  'cry-angel': {
    stationId:'finite-days', scene:'high-camp', object:'campfire', chapter:'finite-days',
    kicker:'The clock is the point', duration:15,
    caption:'“Another 1,000 days if I’m lucky.”',
    editorial:'The clock is the point. Spend finite days on people and mountains that deserve them.',
    light:'ember-blue-hour', weather:'still-cold', camera:'fire-to-sky',
  },
  'geography-risk': {
    stationId:'rope-still-out', scene:'empty-anchor', object:'unfinished-rope', chapter:'loss',
    kicker:'No false closure', duration:15,
    caption:'Steve House, profiled.',
    editorial:'“He never left his mountain. The rope is still not on the ground.”',
    light:'cold-overcast', weather:'snow-grains', camera:'empty-anchor-hold',
  },
  'guides-fall': {
    stationId:'remember-the-guides', scene:'memorial-ridge', object:'memorial-flags', chapter:'loss',
    kicker:'How a profession remembers', duration:14,
    caption:'Dick Jackson. Pearl Street, 2010. Tashi carrying the flag.',
    editorial:'How a profession mourns its own.',
    light:'snow-dawn', weather:'clearing-after-snow', camera:'flags-slow-pass',
  },
  'team-ascent': {
    stationId:'shared-lead', scene:'four-lights', object:'four-rope-team', chapter:'high-point',
    kicker:'Highest occupied point', duration:17,
    caption:'Robbins. Pratt. Frost. Chouinard. North America Wall, 1964.',
    editorial:'The hardest routes fall to teams whose members could each lead—and choose to share the rope.',
    light:'summit-alpenglow', weather:'clouds-opening', camera:'team-to-unfinished-rope',
  },
};

export const majorStations = Object.entries(majorStationSpecs).map(([essayId, station], order) => ({
  order,
  essayId,
  ...station,
}));

const chapterSpecs = [
  {
    id:'departure', label:'Choose your guide', start:0, end:1, altitude:[5430,5686],
    thesis:'Great entrepreneurs choose their guides. Begin with the person, then read the weather and the route.',
    weather:'clear-cold', light:'brick-dawn', sound:'pearl-street-to-meadow',
    camera:'map-table-to-flatirons', pace:'deliberate',
    transition:'The hand-drawn map lifts from Pearl Street brick and becomes the Boulder terrain.',
  },
  {
    id:'protection', label:'Place protection', start:2, end:10, altitude:[5686,7312],
    thesis:'Durability. Original mistakes. No tasty talk. No summit handshake until the ropes—and the capital—are home.',
    weather:'high-thin-cloud', light:'rust-morning', sound:'rope-and-metal',
    camera:'close-to-ground-switchbacks', pace:'measured',
    transition:'Each law becomes a piton; the first anchor resolves at Slater’s Law.',
  },
  {
    id:'place', label:'Take bearings', start:11, end:19, altitude:[7000,8148],
    thesis:'Boulder is the rare place where serious climbing and serious venture work share the same ground.',
    weather:'bluebird-to-building-cloud', light:'front-range-gold', sound:'ponderosa-wind',
    camera:'recognizable-flatirons-profile', pace:'open',
    transition:'The compass turns and the real Flatirons take the full horizon.',
  },
  {
    id:'judgment', label:'Competence, not credentials', start:20, end:27, altitude:[8148,9600],
    thesis:'No money, politics, or ancestry buys an IFMGA pin. The rope goes to the person who can lead.',
    weather:'wind-building', light:'hard-noon', sound:'rope-tension',
    camera:'treeline-to-belay', pace:'focused',
    transition:'The forest falls away. Titles disappear; the rope team becomes visible.',
  },
  {
    id:'exposure', label:'Set the no-go', start:28, end:36, altitude:[9600,11050],
    thesis:'Who runs the company? Who owns it? What is the margin? Decide before the weather decides for you.',
    weather:'front-arriving-to-crosswind', light:'storm-edge', sound:'ridge-wind',
    camera:'continuous-exposed-traverse', pace:'tense',
    transition:'The yellow rope darkens beneath a market front; margin markers appear before the ridge.',
  },
  {
    id:'whiteout', label:'No cairn', start:37, end:41, altitude:[11050,12000],
    thesis:'December 2023 → September 2024. Nine months without a marker. Keep the rope in sight.',
    weather:'whiteout', light:'paper-white', sound:'muffled-wind',
    camera:'low-visibility-rope-follow', pace:'compressed',
    transition:'Markers vanish for nine months. Only the rope and breath remain.',
  },
  {
    id:'finite-days', label:'Another 1,000 days', start:42, end:49, altitude:[12000,13000],
    thesis:'If you are lucky, time is finite. Spend it on people, work, and mountains that deserve it.',
    weather:'still-cold', light:'ember-blue-hour', sound:'fire-and-distant-wind',
    camera:'intimate-camp-to-wide-cirque', pace:'human',
    transition:'A campfire interrupts the scale of the mountain and brings the reader close.',
  },
  {
    id:'loss', label:'Carry the absent', start:50, end:51, altitude:[13000,13600],
    thesis:'Some descents do not resolve. Carry the absent without pretending the mountain is finished.',
    weather:'snow-grains-to-clearing', light:'cold-overcast', sound:'near-silence',
    camera:'empty-anchor-to-memorial-flags', pace:'still',
    transition:'The experience holds on an empty anchor before moving again.',
  },
  {
    id:'high-point', label:'Four can lead', start:52, end:54, altitude:[13600,14259],
    thesis:'Robbins. Pratt. Frost. Chouinard. Each could lead. They shared the rope.',
    weather:'clouds-opening', light:'summit-alpenglow', sound:'wind-and-rope',
    camera:'four-lights-to-downward-turn', pace:'expansive',
    transition:'The camera follows the rope past the team into cloud, then turns toward the unfinished descent.',
  },
];

export const chapters = chapterSpecs.map((chapter, order) => ({ order, ...chapter }));

// Art-directed path hints. Terrain height and normal are sampled at runtime;
// these points only define the horizontal journey through recognizable Boulder
// terrain and the later symbolic high alpine.
export const chronologicalRope = {
  id:'perspectives-rope',
  label:'The Perspectives Expedition',
  color:'#fac832',
  material:'woven-signal-rope',
  essayIds: essays.map((essay) => essay.id),
  terrainConform:'raycast',
  surfaceClearance:0.055,
  continuation:{ afterEssay:'team-ascent', into:'summit-cloud', visibleLength:0.18, resolved:false },
  controlPoints:[
    {x:-0.88,z:-0.92,beat:'pearl-street'},
    {x:-0.69,z:-0.86,beat:'chautauqua'},
    {x:-0.55,z:-0.63,beat:'flatirons-approach'},
    {x:-0.67,z:-0.39,beat:'first-protection'},
    {x:-0.43,z:-0.17,beat:'boulder-reveal'},
    {x:-0.53,z: 0.04,beat:'foothills'},
    {x:-0.25,z: 0.22,beat:'treeline'},
    {x:-0.38,z: 0.41,beat:'exposed-ridge'},
    {x:-0.09,z: 0.55,beat:'whiteout-entry'},
    {x:-0.17,z: 0.70,beat:'high-camp'},
    {x: 0.05,z: 0.81,beat:'memorial-ridge'},
    {x:-0.04,z: 0.93,beat:'high-point'},
  ],
};

const essayChapter = (index) => chapters.find((chapter) => index >= chapter.start && index <= chapter.end);
const stationByEssay = new Map(majorStations.map((station) => [station.essayId, station]));

export const expeditionEssays = essays.map((essay) => {
  const station = stationByEssay.get(essay.id) || null;
  const artifact = artifactTypes[essay.theme];
  const chapter = essayChapter(essay.index);
  const sourceCopy = v4EssayCopy[essay.index];
  return {
    ...essay,
    takeaway: sourceCopy?.line || essay.takeaway,
    hierarchy: station ? 'major-station' : essay.index === 0 ? 'trailhead-note' : 'field-note',
    stationId: station?.stationId || null,
    chapterId: chapter.id,
    artifactType: artifact.id,
    sceneObject: station?.object || artifact.sceneObject,
    // Copy remains traceable to the supplied archive model. No canonical URL
    // is synthesized when the source material did not provide one.
    displayCopy: {
      title: essay.title,
      abstract: sourceCopy?.line || essay.takeaway,
      kicker: station?.kicker || artifact.singular,
    },
  };
});

export const guidedExpedition = [
  { id:'brick-map', chapter:'departure', action:'beginOnMap', target:'mountain-guide-vc', duration:10, caption:'Boulder, Colorado · Read the terrain.', light:'brick-dawn', weather:'clear-cold' },
  { id:'map-becomes-world', chapter:'departure', action:'raiseTerrain', target:'chautauqua', duration:9, caption:'A line leaves the city and enters the foothills.', light:'front-range-dawn', weather:'clear-cold' },
  { id:'master-metaphor', chapter:'departure', action:'enterStation', target:'the-metaphor', duration:14, caption:majorStationSpecs['mountain-guide-vc'].caption, allowOpenEssay:true },
  { id:'laws-as-protection', chapter:'protection', action:'followRope', target:'rope-on-ground', duration:18, caption:'Protection is placed before exposure.', light:'rust-morning', weather:'high-thin-cloud' },
  { id:'slaters-anchor', chapter:'protection', action:'enterStation', target:'rope-on-ground', duration:13, caption:majorStationSpecs['slaters-law'].caption, allowOpenEssay:true },
  { id:'flatirons', chapter:'place', action:'revealLandmark', target:'boulder-reveal', duration:14, caption:'Where you practice changes how you practice.', light:'front-range-gold', weather:'bluebird' },
  { id:'competence', chapter:'judgment', action:'enterStation', target:'earned-authority', duration:13, caption:majorStationSpecs['competence-hierarchy'].caption, allowOpenEssay:true },
  { id:'market-front', chapter:'exposure', action:'weatherArrives', target:'measure-that-matters', duration:15, caption:'Read the people, the ownership, and the conditions.', light:'storm-edge', weather:'front-arriving' },
  { id:'margin', chapter:'exposure', action:'ridgeTraverse', target:'no-go-line', duration:14, caption:majorStationSpecs['markers-margins'].caption, allowOpenEssay:true },
  { id:'whiteout-gap', chapter:'whiteout', action:'timeTraverse', target:'the-personal-reason', duration:18, caption:'Nine months. No marker. The rope continues.', light:'paper-white', weather:'whiteout' },
  { id:'high-camp', chapter:'finite-days', action:'enterStation', target:'finite-days', duration:16, caption:majorStationSpecs['cry-angel'].caption, allowOpenEssay:true },
  { id:'unfinished-loss', chapter:'loss', action:'holdOnAbsence', target:'rope-still-out', duration:16, caption:majorStationSpecs['geography-risk'].caption, allowOpenEssay:true },
  { id:'memorial', chapter:'loss', action:'passMemorial', target:'remember-the-guides', duration:14, caption:majorStationSpecs['guides-fall'].caption, allowOpenEssay:true },
  { id:'four-lights', chapter:'high-point', action:'gatherTeam', target:'shared-lead', duration:17, caption:majorStationSpecs['team-ascent'].caption, allowOpenEssay:true },
  { id:'rope-continues', chapter:'high-point', action:'followBeyond', target:'summit-cloud', duration:12, caption:'Highest occupied point. Not the end.', light:'summit-alpenglow', weather:'clouds-opening' },
  { id:'turn-downhill', chapter:'high-point', action:'turnForDescent', target:'chautauqua', duration:10, caption:'The fund is not done until the rope is on the ground.', light:'late-gold', weather:'clearing' },
].map((beat, order) => ({ order, ...beat }));

export const narrativePrinciples = {
  promise:'A story about judgment under uncertainty, expressed through the physical logic of an expedition.',
  primaryMode:'guided-expedition',
  secondaryMode:'free-explore',
  experienceArc:['choose','protect','orient','judge','endure','gather','remember','share','descend'],
  rules:[
    'One chronological rope, never six parallel infographic routes.',
    'Every visual object has a narrative job.',
    'Major stations earn authored camera, light, weather, and editorial context.',
    'The whiteout makes silence experiential.',
    'Geography begins literally in Boulder and becomes symbolic only in the high alpine.',
    'No summit is framed as completion; the final camera turns toward descent.',
    'No canonical essay URL is invented.',
  ],
};

export const expeditionV5 = {
  version:'5.0',
  title:'Perspectives',
  subtitle:'Field notes from an unfinished ascent',
  timeRange:['2020-10','2026-06'],
  elevationRangeFt:[5430,14259],
  metaphor:{ client:'entrepreneur', guide:'Boulder Ventures', weather:'market', route:'company', completion:'rope on the ground' },
  themes,
  artifactTypes,
  essays:expeditionEssays,
  rope:chronologicalRope,
  landmarks,
  chapters,
  majorStations,
  guidedExpedition,
  narrativePrinciples,
};

export function validateExpeditionV5(data = expeditionV5) {
  const errors = [];
  const ids = new Set(data.essays.map((essay) => essay.id));
  if (data.essays.length !== 55) errors.push(`Expected 55 essays, got ${data.essays.length}`);
  if (ids.size !== data.essays.length) errors.push('Essay ids are not unique');
  if (data.rope.essayIds.length !== 55) errors.push('Chronological rope must carry all 55 essays');
  if (data.rope.essayIds.some((id) => !ids.has(id))) errors.push('Chronological rope references a missing essay');
  if (data.majorStations.length < 10 || data.majorStations.length > 12) errors.push('Expected 10–12 major authored stations');
  if (data.majorStations.some((station) => !ids.has(station.essayId))) errors.push('A major station references a missing essay');
  if (data.essays.some((essay) => essay.canonicalUrl !== null)) errors.push('Unexpected canonical URL: source URLs remain unresolved');
  const covered = data.chapters.flatMap((chapter) => Array.from({length:chapter.end-chapter.start+1},(_,offset)=>chapter.start+offset));
  if (covered.length !== 55 || new Set(covered).size !== 55 || Math.min(...covered) !== 0 || Math.max(...covered) !== 54) {
    errors.push('Chapters must cover essay indices 0–54 exactly once');
  }
  const stationIds = new Set(data.majorStations.map((station) => station.stationId));
  for (const beat of data.guidedExpedition) {
    if (beat.action === 'enterStation' && !stationIds.has(beat.target)) errors.push(`Guided beat references missing station ${beat.target}`);
  }
  return { valid: errors.length === 0, errors };
}
